import { useGetDisplaysetModality } from 'hooks/useGetDisplaysetModality';
import React, { useRef } from 'react';
import { useForm } from 'react-hook-form';

import { ServicesManager } from '@core';
import { Preset } from 'types';
import PresetTable from './PresetTable';
import { SavePresetButton } from './SavePresetButton';
import { UserDefinedPresetForm } from './UserDefinedPresetForm';

/**
 * POPUP Thêm sửa xóa preset
 */
export const UserDefinedPresetWrapper = ({ servicesManager }: { onClose: () => void; servicesManager: ServicesManager }) => {
	const modality = useGetDisplaysetModality(servicesManager);

	const refSubmitButton = useRef<HTMLInputElement>(null);
	const formControls = useForm<Preset>({
		defaultValues: {
			modality: modality,
			name: 'Custom 1',
			ww: 5000,
			wl: 5000,
		},
	});

	const triggerSubmit = () => {
		refSubmitButton?.current?.click();
	};

	return (
		<div className="flex h-64 w-[460px] flex-col gap-2 overflow-hidden p-3">
			<UserDefinedPresetForm refSubmitButton={refSubmitButton} formControls={formControls} modality={modality} />
			<PresetTable formControls={formControls} />
			<SavePresetButton onSave={() => triggerSubmit()} />
		</div>
	);
};
